module.exports = __webpack_public_path__ + "img/crchbp-logo.631be26f.svg";